import { z } from 'zod';

export const ImageGenerateJobInputSchema = z.object({
  brandId: z.string(),
  imageModelId: z.string(),
  imageResolutionPx: z.number().int(),
  /** id of the prompt-fill job whose output supplies the resolved prompt. */
  promptFillJobId: z.string(),
  /** Optional subset of product image ids to attach as references. Empty/undefined = all of the brand's images. */
  productImageIds: z.array(z.string()).optional(),
  /** Per-leaf seed forwarded to the image model. Persisted so retries reproduce the image. */
  seed: z.number().int().optional(),
});
export type ImageGenerateJobInput = z.infer<typeof ImageGenerateJobInputSchema>;

export const ImageGenerateJobOutputSchema = z.object({
  /** Dexie ids of GeneratedImageRow rows produced by this job. */
  generatedImageIds: z.array(z.string()),
  /** Dexie id of the Prediction row written by this job. */
  predictionId: z.string(),
});
export type ImageGenerateJobOutput = z.infer<typeof ImageGenerateJobOutputSchema>;
